export default "/image.2660750d-964c70.png";